import React, { useEffect, useRef, useState } from 'react'
import { createUpdateGroupActions } from 'srcReact/GroupPage'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import config from 'config'
import ImageCropper from 'srcReact/components/common2/ImageCropper'

export default function GroupPicture({
  show,
  hideNextButton,
  nextSectionVisible,
  containerCss,
  verticalLineCss,
  infoCss,
  innerContainerCss,
  titleCss,
  editMode
}) {
  const { t } = useTranslation()
  const containerRef = useRef(null)
  useEffect(() => {
    if (!editMode) {
      containerRef.current.scrollIntoView(true, { behavior: 'smooth' })
    }
  }, [show])
  const dispatch = useDispatch()
  const {
    createUpdateGroup: { selectedWorkplace, groupName, editSuccess, loading, groupInfo },
    common: { isMobile }
  } = useSelector((state) => state)

  const [existingImageUrl, setExistingImageUrl] = useState('')
  const [infoForEditReceived, setInfoForEditReceived] = useState(false)
  const [updateTriggered, setUpdateTriggered] = useState(false)

  useEffect(() => {
    if (editMode && groupInfo && !infoForEditReceived) {
      setInfoForEditReceived(true)
      setExistingImageUrl(groupInfo && groupInfo.picture.id > 0 ? groupInfo.picture.url : '')
    }
  }, [groupInfo])

  useEffect(() => {
    if (editSuccess && updateTriggered) {
      // dispatch(commonActions.fileCreationRemove())
      if (groupInfo && groupInfo.picture) {
        setExistingImageUrl(groupInfo.picture.path)
      }
      setUpdateTriggered(false)
    }
  }, [editSuccess])

  const handleSkip = () => {
    dispatch(createUpdateGroupActions.setSkipPicture())
    dispatch(createUpdateGroupActions.showDescription())
    if (nextSectionVisible) {
      const nextContainer = document.querySelector('#descriptionContainer')
      nextContainer.scrollIntoView(true, { behavior: 'smooth' })
    }
  }

  const handleNext = (uploadedFile) => {
    if (selectedWorkplace.id > 0) {
      if (uploadedFile) {
        dispatch(createUpdateGroupActions.setGroupPicture(uploadedFile))
      }
      dispatch(createUpdateGroupActions.showDescription())
    }
  }

  const handleSave = (picture) => {
    setUpdateTriggered(true)
    dispatch(
      createUpdateGroupActions.editGroup(groupInfo.id, {
        picture_id: picture ? picture.id : 0,
        picture_name: picture ? picture.filename : '',
        picture_mime_type: picture ? picture.mimeType : ''
      })
    )
  }

  return (
    <React.Fragment>
      <div
        id='imageUploadContainer'
        ref={containerRef}
        className={`${containerCss} ${!nextSectionVisible && !editMode && styles.container} ${
          show === true ? styles.show : styles.hide
        }`}>
        <div className={verticalLineCss} />
        {!editMode && (
          <React.Fragment>
            <p className={infoCss}>{t('group.createGroup.groupPicture.title1')}</p>
          </React.Fragment>
        )}

        <div className={`${styles.innerContainer} ${innerContainerCss}`}>
          <h2 className={titleCss}>
            {editMode ? t('group.editGroup.groupPictureTitle') : t('group.createGroup.groupPicture.title2')}
          </h2>

          {/* <p className={styles.info}>{t('group.createGroup.groupPicture.info')}</p> */}
          <p className={styles.info}>
            {isMobile
              ? t('group.createGroup.groupPicture.uploadInfoMobile')
              : t('group.createGroup.groupPicture.uploadInfo')}
          </p>
          <ImageCropper
            isMobile={isMobile}
            editMode={editMode}
            handleSave={handleSave}
            handleSkip={handleSkip}
            handleNext={handleNext}
            hideNextButton={hideNextButton}
            entityUpdated={editSuccess}
            entityUpdating={loading}
            aspectRatio={isMobile ? 10 / 5 : 622 / (622 * 0.34)}
            exisingImageUrl={existingImageUrl}
            text={groupName ? groupName.value : ''}
            showUploadZone={true}
            containerCSS={styles.imageContainer}
          />
        </div>
      </div>
    </React.Fragment>
  )
}
